import { NavLink } from 'react-router-dom'
import { Icon, type IconName } from '@/components/Icon'
import { cx } from '@/lib/cx'

/** Six is more than a tab bar usually carries, but burying two behind a "More"
 *  sheet costs a tap every single time. */
const TABS: { to: string; label: string; icon: IconName; end?: boolean }[] = [
  { to: '/', label: 'Home', icon: 'home', end: true },
  { to: '/patients', label: 'Patients', icon: 'users' },
  { to: '/callers', label: 'Callers', icon: 'phone' },
  { to: '/appointments', label: 'Appts', icon: 'calendar' },
  { to: '/travel', label: 'Travel', icon: 'pin' },
  { to: '/calendar', label: 'Calendar', icon: 'chart' },
]

/** Inside the thumb arc, above the home indicator. Phones only. */
export function TabBar() {
  return (
    <nav
      aria-label="Main"
      className="sticky bottom-0 z-sticky flex border-t border-line-soft bg-surface pb-safe lg:hidden"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end ?? false}
          className={({ isActive }) =>
            cx(
              'flex min-h-14 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-0.5 py-2 text-[0.6875rem] font-medium no-underline',
              isActive ? 'text-accent' : 'text-fg-subtle',
            )
          }
        >
          <Icon name={tab.icon} />
          {/* "Appts" on the tab, "Appointments" to a screen reader: six labels
              across 360px leaves no room for the full word. */}
          <span className="max-w-full truncate">{tab.label}</span>
          {tab.label === 'Appts' && <span className="sr-only">Appointments</span>}
        </NavLink>
      ))}
    </nav>
  )
}
